import uniq from 'lodash/uniq';
import { createSelector } from 'reselect';

import { getFilteredShops } from './';

export default filterOn =>
  createSelector([getFilteredShops], shops =>
    uniq(Object.values(shops).map(shop => shop[filterOn])).sort()
  );
